export default __webpack_public_path__ + "static/media/IconDoc.7d853e85.svg";